import { render } from "./adminLogin.vue?vue&type=template&id=52741890"
import script from "./adminLogin.vue?vue&type=script&lang=js"
export * from "./adminLogin.vue?vue&type=script&lang=js"

import "./adminLogin.vue?vue&type=style&index=0&id=52741890&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__